import {
  InfoBanner,
  InfoIcon,
  SquareNewWindowIcon,
  Typography,
  useToast,
} from "@codat/orchard-ui";
import React from "react";

import { usePostZapierTokenMigration } from "components/Onboarding/hooks/usePostZapierTokenMigration";

import styles from "./Home.module.scss";

interface MigrationBannerProps {
  onError: () => void;
  onClose: () => void;
}

const MigrationBanner = ({ onClose, onError }: MigrationBannerProps) => {
  const { postFeed } = usePostZapierTokenMigration({ migrationHelp: true });
  const { addToast } = useToast();
  return (
    <InfoBanner
      className={styles.bannerWrapper}
      data-testid="migration-banner"
      title={
        <Typography variant="heading_sm" as="h4" className={styles.bannerTitle}>
          Already have other integrations?
        </Typography>
      }
      subtitle={
        <Typography variant="body_sm" as="p" className={styles.bannerSubtitle}>
          Moving live integrations to Codat is easy. We do the hard work and
          your users stay connected without taking any action.
        </Typography>
      }
      icon={<InfoIcon className={styles.migrationBannerInfoIcon} />}
      buttons={[
        {
          label: "Get help migrating",
          variant: "primary",
          onClick: () => {
            onClose();
            postFeed()
              .then(() => {
                addToast({
                  message: "We'll be in touch",
                  subText:
                    "Someone will reach out to you shortly to discuss your migration needs.",
                  variant: "success",
                });
              })
              .catch(() => {
                onError();
                addToast({
                  message:
                    "Something went wrong with this request. Please try again.",
                  variant: "error",
                });
              });
          },
          ["data-testid"]: "migration-get-help-button",
        },
        {
          children: (
            <>
              Read our migration documentation
              <SquareNewWindowIcon className={styles.bannerNewTabIcon} />
            </>
          ),
          color: "interface",
          label: "Read our migration documentation",
          variant: "secondary",
          onClick: () => {
            window.open(
              "https://docs.codat.io/get-started/migration",
              "_blank"
            );
          },
          ["data-testid"]: "migration-docs-link-button",
        },
      ]}
      onClose={onClose}
    />
  );
};

export default MigrationBanner;
